//any side effects or async calls

import { put, call } from "redux-saga/effects";
import request from "../../utils/request";
import * as actions from "../actions/dashboardAction";
import moment from "moment";
import { store } from "../..";
import { RECENT_LOADER, DAILY_LOADER, CS_LOADER, VENDOR_LOADER } from "../actions/actionTypes";
import { toast } from "react-toastify";
import { SUPPLIER_PATH } from "../../config/path";

export function* dashboard(action) {

}

export function* getRecentChecks(action) {
  store.dispatch({ type: RECENT_LOADER, payload: true })
  const requestURL = `${SUPPLIER_PATH}/get-recent-check?section=RecentChecks&fromDate=${moment().subtract(14, "days").format('MMDDYYYY')}&vendorNumber=${action.payload.length !== 0 ? encodeURIComponent(action.payload.toString().replace(/,/g, "|")) : ""}`;

  const requestAttrs = {
    method: "GET"
  };
  try {
    const dashBoardResponse = yield call(request, requestURL, requestAttrs);
    let data = dashBoardResponse.rows[0].recentChecks;
    yield put(actions.setRecentChecks(data ? data : []));
  } catch (err) {
    toast.error("Failed to load Recent Checks, please reload.", { autoClose: false });
  } finally {
    store.dispatch({ type: RECENT_LOADER, payload: false });
  }
}

export function* getPendingPayableReport(action) {
  store.dispatch({ type: DAILY_LOADER, payload: true })
  const requestURL = `${SUPPLIER_PATH}/get-recent-check?section=PendingPayables&fromDate=${moment().day() === 1 ? moment().subtract(3, "days").format('MMDDYYYY') : moment().subtract(1, "days").format('MMDDYYYY')}&vendorNumber=${action.payload.length !== 0 ? encodeURIComponent(action.payload.toString().replace(/,/g, "|")) : ""}`;
  const requestAttrs = {
    method: "GET"
  };
  try {
    const dashBoardResponse = yield call(request, requestURL, requestAttrs);
    let data = dashBoardResponse.rows[0].recentChecks;
    yield put(actions.setPendingPayableReport(data ? data : []));
  } catch (err) {
    toast.error("Failed to load Daily pending payable report, please reload.", { autoClose: false });
  } finally {
    store.dispatch({ type: DAILY_LOADER, payload: false });
  }
}

export function* getVendorDownloadLink(action) {
  store.dispatch({ type: VENDOR_LOADER, payload: true });
  const requestURL = `${SUPPLIER_PATH}/get-vendor-download-links?vendorId=${action.payload}`;
  const requestAttrs = {
    method: "GET"
  };
  try {
    const response = yield call(request, requestURL, requestAttrs);
    let data = response.rows[0].vendorDownloadLinks;
    yield put(actions.vendorDownloadLinkSuccess(data ? data : []));
  } catch (err) {
    toast.error("Failed to load Vendor download links, please reload.", { autoClose: false });
  } finally {
    store.dispatch({ type: VENDOR_LOADER, payload: false });
  }
}
